import React, { useState } from 'react'
import Loader from '../atoms/Loader'

interface SandboxedFrameProps {
  title: string
  src?: string
  srcDoc?: string
}

// the frame keeps loading after it mounts, so track its own load to avoid a blank box
const SandboxedFrame: React.FC<SandboxedFrameProps> = ({ title, src, srcDoc }) => {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <div className="relative h-full w-full">
      {isLoading && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-900">
          <Loader className="text-light-green-500" />
        </div>
      )}
      {/* sandbox stays at allow-scripts only: allow-same-origin would let the frame reach the parent app. */}
      <iframe
        src={src}
        srcDoc={srcDoc}
        className="h-full w-full border-0"
        title={title}
        sandbox="allow-scripts"
        referrerPolicy="no-referrer"
        onLoad={() => setIsLoading(false)}
      />
    </div>
  )
}

export default SandboxedFrame
